var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayHamburgerMenuChatSecondary = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.462 4.8H5.91C4.278 4.8 2.4 6.263 2.4 7.673v11.342c0 1.298 1.591 2.236 3.118 2.38L4.525 25.2l6.365-3.778h13.572c1.632 0 3.138-.998 3.138-2.407V7.673c0-1.41-1.507-2.873-3.138-2.873zM8.74 14.374a1.683 1.683 0 0 1-1.676-1.69c0-.934.75-1.69 1.676-1.69.924 0 1.676.756 1.676 1.69 0 .933-.752 1.69-1.676 1.69zm6.259 0a1.683 1.683 0 0 1-1.676-1.69c0-.934.75-1.69 1.676-1.69.926 0 1.676.756 1.676 1.69 0 .933-.75 1.69-1.676 1.69zm6.26 0a1.684 1.684 0 0 1-1.677-1.69c0-.934.752-1.69 1.677-1.69.924 0 1.676.756 1.676 1.69 0 .933-.752 1.69-1.676 1.69z",
    fill: "#1E2969",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayHamburgerMenuChatSecondary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-hamburger-menu-chat-secondary.d7d265aa1feb3704ae538de3e691bedb.svg";